import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAuthStore = create(
    persist(
        (set) => ({
            user: null,
            token: null,
            isAuthenticated: false,
            isLoading: false,
            error: null,

            // Actions
            setUser: (user) => set({
                user
            }),
            
            setIsAuthenticated: (isAuth) => set({ isAuthenticated: isAuth }),
            setToken: (token) => set({ token }),

            setLoading: (loading) => set({ isLoading: loading }),

            setError: (error) => set({ error }),

            clearError: () => set({ error: null }),

            login: async (email, password) => {
                set({ isLoading: true, error: null });

                try {

                    const mockUser = {
                        id: "34141",
                        email: "aadad@sds.com",
                        firstName: "Siegfred",
                        lastName: "Madeghe",
                        role: "user"
                    };

                    const mockToken = "fake-jwt-token-123456789";

                    set({
                        user: mockUser,
                        token: mockToken,
                        isAuthenticated: true,
                        isLoading: false,
                        error: null,
                    });

                    localStorage.setItem('auth_token', mockToken);

                } catch (error) {
                    const message = error.message || 'Login failed';
                    set({
                        error: message,
                        isLoading: false,
                    });
                    throw error;
                }
            },

            register: async (data) => {
                set({ isLoading: true, error: null });

                try {
                    // Uncomment when you have real backend
                    /*
                    const response = await fetch('http://localhost:5000/api/v1/auth/register', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                      },
                      body: JSON.stringify(data),
                    });
          
                    if (!response.ok) {
                      const error = await response.json();
                      throw new Error(error.message || 'Registration failed');
                    }
          
                    const result = await response.json();
                    */

                    // Mock successful registration
                    const mockUser = {
                        id: "98765",
                        email: data.email,
                        firstName: data.firstName,
                        lastName: data.lastName,
                        role: "user"
                    };

                    const mockToken = "fake-jwt-token-after-register";

                    set({
                        user: mockUser,
                        token: mockToken,
                        isAuthenticated: true,
                        isLoading: false,
                        error: null,
                    });

                    localStorage.setItem('auth_token', mockToken);

                } catch (error) {
                    const message = error.message || 'Registration failed';
                    set({
                        error: message,
                        isLoading: false,
                    });
                    throw error;
                }
            },

            logout: () => {
                localStorage.removeItem('auth_token');
                set({
                    user: null,
                    token: null,
                    isAuthenticated: false,
                    error: null,
                });
            },
        }),
        {
            name: 'auth-storage', // key in localStorage
            partialize: (state) => ({
                user: state.user,
                token: state.token,
                isAuthenticated: state.isAuthenticated,
            }),
        }
    )
);